import React from "react";
import useStore from "../../../useStore";
import { useForm } from "../../../Hooks/useForm";
import { FORM_CONTACT } from "../../../Constants/Contact";
import { CONTACT_EMAIL } from "../../../Constants/Home";
import { FormContactScheme } from "../../../Models/Schemas/form-contact";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import Input from "../../Elements/Input/Input";
import Button from "../../Elements/Button/Button";
import Loader from "../../Elements/Loader/Loader";
import { useTranslation } from "../../../Hooks/useTranslation";
import { showAlert } from "../../../Utilities/Alerts/alert";

const Contact = () => {
  const { fetchSendContact, loading, resetError, resetSuccess } = useStore();
  const { t, language } = useTranslation();

  const { values, errors, touched, isValid, handleChange, handleBlur, handleSubmit, resetForm } =
    useForm(FORM_CONTACT, FormContactScheme(t.contact.validation), async (formValues) => {
      const { sent, statusCode } = await fetchSendContact({ ...formValues, language });
      resetError();
      resetSuccess();

      if (sent) {
        resetForm();
        showAlert({
          status: "success",
          title: t.contact.successTitle,
          text: t.contact.success,
          confirmText: t.contact.confirm,
        });
        return;
      }

      const invalid = statusCode === 400;
      showAlert({
        status: invalid ? "warning" : "error",
        title: invalid ? t.contact.invalidTitle : t.contact.errorTitle,
        text: invalid ? t.contact.invalid : t.contact.error,
        confirmText: t.contact.confirm,
      });
    });

  const messageError = setErrorFormSimpleUtil(errors, touched, "message");

  return (
    <section id="contacto" className="section">
      {loading && <Loader message={t.contact.sending} />}
      <div className="container contact" data-reveal>
        <div>
          <span className="eyebrow">{t.contact.eyebrow}</span>
          <h2>{t.contact.title}</h2>
          <p className="section-text">
            {t.contact.textStart}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
        </div>
        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          <Input
            label={t.contact.name}
            name="name"
            placeholder={t.contact.namePlaceholder}
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={setErrorFormSimpleUtil(errors, touched, "name")}
          />
          <Input
            label={t.contact.email}
            name="email"
            type="email"
            placeholder={t.contact.emailPlaceholder}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={setErrorFormSimpleUtil(errors, touched, "email")}
          />
          <div className={`casvi-input ${messageError ? "has-error" : ""}`}>
            <label htmlFor="message">{t.contact.message}</label>
            <textarea
              id="message"
              name="message"
              rows={5}
              placeholder={t.contact.messagePlaceholder}
              value={values.message}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {messageError && <span className="casvi-input-error">{messageError}</span>}
          </div>
          <input
            className="contact-honeypot"
            type="text"
            name="website"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            value={values.website}
            onChange={handleChange}
          />
          <Button text={t.contact.submit} type="submit" disabled={!isValid || loading} />
        </form>
      </div>
    </section>
  );
};

export default Contact;
